import { useTranslation } from 'react-i18next';
import { GROUPS, type SettingsGroup } from './model/groups';

type MainSettingsAsideProps = {
    group: SettingsGroup;
    onSelect: (key: SettingsGroup) => void;
};

const MainSettingsAside = ({ group, onSelect }: MainSettingsAsideProps) => {
    const { t } = useTranslation(['Settings']);

    return (
        <div className="main-settings-aside">
            <div
                className="text-muted text-uppercase fw-semibold mb-2 px-1"
                style={{ fontSize: 11 }}
            >
                {t('mainParams.navTitle')}
            </div>
            <div className="d-flex flex-column gap-2">
                {GROUPS.map(({ key, Icon }) => {
                    const active = group === key;
                    return (
                        <button
                            key={key}
                            type="button"
                            onClick={() => onSelect(key)}
                            className={`main-settings-aside-item text-start ${
                                active ? 'is-active' : ''
                            }`}
                        >
                            <span
                                className={`main-settings-aside-icon ${
                                    active ? 'is-active' : ''
                                }`}
                            >
                                <Icon width={18} height={18} />
                            </span>
                            <span className="min-w-0">
                                <span className="d-block fw-semibold lh-sm">
                                    {t(`mainParams.groups.${key}.title`)}
                                </span>
                                <span className="d-block fs-12 text-muted mt-1">
                                    {t(`mainParams.groups.${key}.subtitle`)}
                                </span>
                            </span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default MainSettingsAside;
